import { render, staticRenderFns } from "./order-overview.vue?vue&type=template&id=60ce0f5c&scoped=true"
import script from "./order-overview.vue?vue&type=script&lang=js"
export * from "./order-overview.vue?vue&type=script&lang=js"
import style0 from "./order-overview.vue?vue&type=style&index=0&id=60ce0f5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ce0f5c",
  null
  
)

export default component.exports